import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { CompanyLink } from "@/lib/company-social-links";
import { cn } from "@/lib/utils";

function ExternalLinkButton({ link }: { link: CompanyLink }) {
  const Icon = link.icon;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <a
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.label}
          className={cn(
            "inline-flex items-center justify-center w-9 h-9 max-sm:size-11 rounded-lg border border-border bg-background text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors",
            link.colorClass,
          )}
        >
          <Icon className="w-4 h-4" />
        </a>
      </TooltipTrigger>
      <TooltipContent side="top">{link.label}</TooltipContent>
    </Tooltip>
  );
}

/**
 * The row of icon links of a company header — website, social accounts,
 * registries, map — each named by its tooltip. Shared by the company panel
 * and the web preview so both show the same row.
 */
export default function CompanyExternalLinks({
  links,
  className = "mt-4",
}: {
  links: CompanyLink[];
  className?: string;
}) {
  if (links.length === 0) return null;
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {links.map((link) => (
        <ExternalLinkButton key={link.url} link={link} />
      ))}
    </div>
  );
}
